const routes = {
    home: {
        path: '/',
        name: 'home'
    },
    survey: {
        path: '/survey',
        name: 'survey'
    },
    thankYouPage: {
        path: '/thank-you-page',
        name: 'thank-you-page'
    },
    send: {
        path: '/send',
        name: 'send'
    },
};

export default routes;
